import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IItineraryFacility } from "../itineraryfacilityModel";

export const getAllItineraryFacility = createAsyncThunk(
  "ItineraryFacilities/FindAll",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/ItineraryFacilities/FindAll`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Itinerary:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createItineraryFacility = createAsyncThunk(
  "ItineraryFacilities/InsertItineraryFacilities",
  async (ItineraryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ItineraryFacilities/InsertItineraryFacilities`,
        ItineraryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Itinerary:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateItineraryFacility = createAsyncThunk(
  "ItineraryFacilities/UpdateItineraryFacilities",
  async (ItineraryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ItineraryFacilities/UpdateItineraryFacilities`,
        ItineraryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Itinerary Facility:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteItineraryFacility = createAsyncThunk(
  "ItineraryFacilities/Delete",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ItineraryFacilities/Delete`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Itinerary Facility", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
export const getItineraryFacilityByID = createAsyncThunk(
  "ItineraryFacilities/FindByID",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ItineraryFacilities/FindByID`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Name: result?.Name,
        FacilityImage: result?.FacilityImage,
        IsActive: result?.IsActive ? 1 : 2,
      } as IItineraryFacility;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Itinerary Facility:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveItineraryFacility = createAsyncThunk(
  "ItineraryFacilities/FindAllActive",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/ItineraryFacilities/FindAllActive`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching  Itinerary Facility:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveItineraryFacility = createAsyncThunk(
  "ItineraryFacilities/Active-InActive",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ItineraryFacilities/Active-InActive`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Itinerary Facility", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const itineraryFacilityImageUpload = createAsyncThunk(
  "ItineraryFacilities/FacilityImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ItineraryFacilities/FacilityImageUpdate`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Itinerary Facility Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
